<template>
  <div class="container">
    <el-button type="text" size="mini" @click="publishDialogShow = true"
      >发布</el-button
    >
    <el-dialog
      title="自定义模块机器列表"
      :visible.sync="customModuleDialogShow"
      width="600"
    >
      <span class="danger-text">请注意: 以下机器正在使用的为特殊模块, 请选择是否使用通用模块</span>
      <zx-vv-table
        :config="customMachineConfig"
        :data="customMachineListFilter"
        v-model="selectedMachine"
        valueKey="machine_uuid"
        :moduleType="moduleType"
      >
      </zx-vv-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelPublish" size="mini">取 消</el-button>
        <el-button type="primary" @click="confirmPublish" size="mini"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="请选择需要发布的餐厅"
      :visible.sync="publishDialogShow"
      width="600"
    >
      <zx-vv-table
        :config="tableConfig"
        :data="machineList"
        :valueKey="valueKey"
        v-model="selectedRows"
      >
        <template slot="seach-box">
          <el-input
            class="search-box"
            size="mini"
            v-model="searchText"
            placeholder="快速搜索"
          ></el-input>
        </template>
      </zx-vv-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelPublish" size="mini">取 消</el-button>
        <el-button type="primary" @click="confirmPublish" size="mini"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import zxVvTable from './zxVvTable';
import pinyinMatch from 'pinyin-match';
import {apiPublishApiModule, apiPublishClientApp, apiPublishFoodModel, apiPublishRegionModel} from '@/api';

const [
  CLIENT_APP,
  DETECTED_API,
  FOOD_MODEL,
  DETECTED_REGION_MODEL,
  DISH_MODEL] = [1, 2, 3, 4, 5];
export default {
  name: "",
  components: {
    zxVvTable
  },
  props: {
    module_uuid: {
      type: String
    },
    moduleType: {
      type: Number
      // 1 app主版本模块，2 api识别模块，3 菜品模型，4 检测框模型，5 碗碟注册模型
    }
  },
  data() {
    return {
      selectedMachine: [],
      valueKey: "machine_uuid",
      searchText: "",
      publishDialogShow: false,
      customMachineConfig: [
        { prop: "eatery_name", name: "食堂" },
        { prop: "canteen_name", name: "餐厅" },
        { prop: "machine_name", name: "机器名称" },
        { prop: "machine_id", name: "机器ID" },
        { prop: "_action", name: "操作", actionName: "event_slot" }
      ],
      tableConfig: [
        { prop: "eatery_name", name: "食堂" },
        { prop: "canteen_name", name: "餐厅" },
        { prop: "machine_name", name: "机器名称" },
        { prop: "machine_id", name: "机器ID" }
      ],
      selectedRows: [],
      customModuleDialogShow: false
    };
  },
  mounted() {},
  methods: {
    ...mapActions([]),
    getCustomMachinelsit() {
      this.apiGetCustomMachine();
    },
    cancelPublish() {
      this.selectedRows = [];
      this.selectedMachine = [];
      this.customModuleDialogShow = false;
      this.publishDialogShow = false;
    },
    async confirmPublish() {
      if (this.publishToAll && !this.customModuleDialogShow) {
        // 发布到全部的餐厅
        this.customModuleDialogShow = true;
      } else {
        await this.publish();
        this.cancelPublish();
        this.$emit('completed');
      }
    },
    async publish() {
      const publishClientApp = async () => {
        // 发布主客户端
        await apiPublishClientApp(
          this.canteen_machine_list,
          this.publishToAll ? "1" : "0",
          this.module_uuid
        );
      };
      const publishDetectedApi = async () => {
        // 发布识别模块
        await apiPublishApiModule(
          this.canteen_machine_list,
          this.publishToAll ? "1" : "0",
          this.module_uuid
        );
      };
      const publishFoodModel = async () => {
        // 发布菜品模型
        await apiPublishFoodModel(
          this.canteen_machine_list,
          this.publishToAll ? "1" : "0",
          this.module_uuid
        );
      };
      const publishDetectedRegionModel = async () => {
        // 发布识别框模块
        await apiPublishRegionModel(
          this.canteen_machine_list,
          this.publishToAll ? "1" : "0",
          this.module_uuid
        );
      };
      const publishDishMode = () => {
        // 发布碗碟模型
      };
      console.log(this.moduleType, CLIENT_APP);
      switch (this.moduleType) {
        case CLIENT_APP:
          // 发布主客户端
          try {
            await publishClientApp();
            this.$message.success("发布成功");
          } catch (e) {
            console.log(e);
            this.$message.error("发布失败" + e.message);
          }
          break;
        case DETECTED_API:
          // 发布识别模块
          try {
            await publishDetectedApi();
            this.$message.success("发布成功");
          } catch (e) {
            console.log(e);
            this.$message.error("发布失败" + e.message);
          }
          break;
        case FOOD_MODEL:
          try {
            await publishFoodModel();
            this.$message.success("发布成功");
          } catch (e) {
            console.log(e);
            this.$message.error("发布失败" + e.message);
          }
          break;
        case DETECTED_REGION_MODEL:
          try {
            await publishDetectedRegionModel();
            this.$message.success("发布成功");
          } catch (e) {
            console.log(e);
            this.$message.error("发布失败" + e.message);
          }
          break;
        case DISH_MODEL:
          console.log("");
          break;
        default:
          return this.$message.error("模型类型出错, 请检查");
      }
    }
  },
  computed: {
    ...mapGetters(["allMachineList", "customMachineList"]),
    publishToAll() {
      if (this.selectedRows.length === 0) {
        return false;
      } else {
        return this.$_.isEmpty(
          this.$_.differenceBy(
            this.allMachineList,
            this.selectedRows,
            "machine_uuid"
          )
        );
      }
    },
    customMachineListFilter() {
      const type = this.moduleType;
      let list = this.$_.cloneDeep(this.customMachineList);
      list.forEach(a => {
        let target = this.$_.find(
          this.allMachineList,
          b => b.machine_uuid === a.machine_uuid
        );
        if (target) {
          this.$set(a, "canteen_name", target.canteen_name);
          this.$set(a, "eatery_name", target.eatery_name);
          this.$set(a, "machine_name", target.machine_name);
          this.$set(a, "machine_id", target.machine_id);
        }
      });
      return list.filter(a => {
        if (a.custom_module_list.length > 0) {
          return a.custom_module_list.indexOf(type) !== -1;
        }
      });
    },
    canteen_machine_list() {
      let list = this.$_.groupBy(
        this.customModuleDialogShow ? this.selectedMachine : this.selectedRows,
        "canteen_id"
      );
      let values = this.$_.values(list);
      let keys = this.$_.keys(list);
      let arr = keys.map((a, idx) => {
        return {
          canteen_id: a,
          // todo: 以后改为machine_uuid
          machine_uuid_list: list[a].map(b => b.machine_uuid)
        };
      });
      return arr;
    },
    machineList() {
      let list = this.allMachineList;
      let seachText = this.searchText;
      console.log(seachText);
      if (!seachText) {
        return list;
      } else {
        return list.filter(a => {
          let text =
            a.canteen_name + "," + a.eatery_name + "," + a.machine_name;
          let res = pinyinMatch.match(text, seachText);
          return res.length > 0;
        });
      }
    }
  },
  watch: {
    customModuleDialogShow(val) {
      if (val) {
        this.$store.dispatch("setCustomMachineList");
      }
    }
  }
};
</script>
<style lang="scss">
  .el-dialog__body {
    padding: 0;
  }
</style>
<style lang="scss" scoped>
.container {
  display: inline-block;
  .search-box {
    display: inline-block;
    width: 200px;
  }
}
</style>
